/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Buffer } from 'buffer';

import { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Modal, Button, Toast, Spinner } from 'react-bootstrap';

// project imports
import store from 'features/store';
import { AppRouter } from 'features/routers/AppRouter';
import { checkRefreshToken, isAuthorized, logout } from 'shared/settings/auth';
import { Register } from './../../register/Register';
import { Signin } from './../../signin/Signin';
import { ForgotPassword } from './../../forgot-password/ForgotPassword';

import { CheckExists } from 'features/components/register/CheckExists';
import ErrorModal from 'features/components/register/ErrorModal';
import NotificationModal from '../notification-modal/NotificationModal';

import { FooterNew, Header } from '.';

import { ErrorBoundary } from 'shared/utils';

import Helmet from 'react-helmet';

// style imports
import './AppLayout.scss';
import CommonMethods from 'shared/utils/CommonMethods';
import MembershipModal from '../auth-pages/MembershipModal/MembershipModal';
import { MobileAppBanner } from './MobileAppBanner';
import ExploreFilterUI from '../public/HOC/ExploreFilterUI';
import { crossIcon } from 'shared/assets/icons';

const AppLayoutNew = (props) => {

    const reduxState = useSelector(state => state);

    const [showHelmet, setShowHelmet] = useState(true);
    const [refreshLoading, setRefreshLoading] = useState(false);

    useEffect(() => {
        window.addEventListener('online', () => toggleOnlinePopup(false), false);
        window.addEventListener('offline', () => toggleOnlinePopup(true), false);

        return () => {
            window.removeEventListener('online', () => toggleOnlinePopup(false), false);
            window.removeEventListener('offline', () => toggleOnlinePopup(true), false);
        }
    }, []);


    useEffect(() => {
        const scrollContainer = document.querySelector('.scroll-content');
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        } else {
            window.scrollTo(0, 0);
        }
    }, [props.location.pathname]);
    
    useEffect(() => {
        store.dispatch({ type: 'TOGGLE_SIDEBAR', payload: false });

        const pathName = props.location.pathname;

        const locationSalesRegex = /^\/locations\/[^/]*[^/]*\/sales[^/]*$/mgi;
        const locationSales = locationSalesRegex.exec(pathName);

        const estateSalesRegex = /^\/estate-sale\/(\d+)$/;
        const estateSalesList = estateSalesRegex.exec(pathName);

        const saleItemsRegex = /^\/estate-sale\/(\d+)\/item\/(\d+)\/(\b[a-zA-Z0-9 !-@#$%^&*)({}]+)/;
        const saleItems = saleItemsRegex.exec(pathName);

        const seoPages = ['/', '/estate-sale/list', '/locations', '/ourstory', '/my-account/premier/member-benefits', '/my-account/premier/total-access', '/my-account/premier/alzheimers-foundation', '/my-account/premier/advisor', '/my-account/premier/auction-sneak-peak', '/my-account/premier/delivery-guarantee', '/my-account/premier/premier-account', '/my-account/premier/worthpoint', '/my-account/join-premier-member', '/my-account/premier/premier-membership', "/plans", "/explore"];

        if (locationSales || seoPages.includes(pathName) || estateSalesList || saleItems) {
            setShowHelmet(false);
        } else {
            setShowHelmet(true);
        }
    }, [props.location.pathname]);

    const toggleOnlinePopup = (flag) => {
        store.dispatch({ type: 'OFFLINE_POPUP', payload: flag });
    }

    const toggleSideBar = () => {
        store.dispatch({ type: 'TOGGLE_SIDEBAR', payload: false });
    };

    const tokenRefresh = () => {
        setRefreshLoading(true);
        checkRefreshToken().then(res => {
            // store.dispatch({ type: 'TOGGLE_REFRESH_MODAL', payload: false });
            setRefreshLoading(true);
        }).catch(err => {
            setRefreshLoading(true);
        });
    };

    const signIn = (event) => {
        const encoded = Buffer.from(props.history.location.pathname).toString("base64");
        if (event && !isAuthorized()) {
            const paramsValue = props.history.location.search;
            const decoded = Buffer.from(paramsValue, "base64").toString("ascii");
            if (!decoded) {
                logout(props.history, true, encoded);
            }
        }
        store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: false });
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: "Sign-In" } });
    }

    const closeSessionModel = () =>{
        store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: false })
    }

    const logoutUser = (event) => {
        if (event) {
            logout(props.history);
        }

        store.dispatch({ type: 'TOGGLE_LOGOUT_MODAL', payload: false });
    };

    return (
        <div className={`d-flex flex-column layout ${reduxState.showOffilePopUp ? 'no-internet' : ''}`} style={{ overflowX: "hidden" }}>
            {
                showHelmet ?
                <Helmet>
                    <title>CTBids</title>
                    <meta name='description' content="CTBids buyers web app" />
                    <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                    <link rel="canonical" href={`https://ctbids.com${props.history.location.pathname}`} />
                </Helmet> : null
            }
            {
                reduxState.showOffilePopUp ? 
                <Toast className="toast-handle">
                    <Toast.Body>Whoops! No internet connection found. Check your connection or <span className="clickable refresh-page" onClick={() => { window.location.reload(); }}>Try Again</span></Toast.Body>
                </Toast>: null
            }

            <MobileAppBanner />

            {
                reduxState.header ?
                <div className={`top-layout ${reduxState.user.id ? 'setHeight' : ''} `}>
                    <Header {...props} />
                </div>
                : null
            }

            <div className="scroll-content">
                <ErrorBoundary {...props}>
                    <AppRouter />
                </ErrorBoundary>
                {
                    reduxState.footer && !props.location?.pathname.includes('/my-account') ?
                    <div className="bottom-layout">
                        <FooterNew {...props} />
                    </div> : null
                }
            </div>

            <Modal centered show={reduxState.logoutModal} size="sm" animation={false} backdrop="static" keyboard={false}>
                <Modal.Body>
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        Are you sure you wish to signout?
                        <div className="d-flex flex-row mt-4">
                            <Button variant="outline-dark btn-white mx-2" style={{ width: '60px' }} onClick={() => logoutUser(false)}>No</Button>
                            <Button variant="btn btn-secondary" style={{ width: '60px' }} onClick={() => logoutUser(true)}>Yes</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal centered show={reduxState.sessionModal} size="sm" animation={false} backdrop="static" keyboard={false}>
                <Modal.Body>
                <div className="w-100 d-flex justify-content-end" style={{ marginBottom: "10px" }}>
                        <img role='button' src={`${process.env.PUBLIC_URL}/static/icons/common-icons/close.svg`} alt="Close button"  style={{ width: "20px" }} onClick={() => closeSessionModel()} />
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        Your session has expired. Please login.
                        <div className="d-flex flex-row mt-4">
                            <Button variant="secondary mx-2" style={{ width: '120px' }} onClick={() => signIn(true)}>Login</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal centered show={reduxState.refreshModal} size="sm" animation={false} backdrop="static" keyboard={false}>
                <Modal.Body>
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        Oops, something went wrong... {isAuthorized() ? "Try to refresh the page, or log out and log in again." : "Try to refresh the page."}
                        <div className="d-flex flex-row mt-4">
                            <Button variant="secondary mx-2" style={{ width: '120px' }} onClick={tokenRefresh} disabled={refreshLoading}>
                                Refresh {refreshLoading ? <Spinner as="span" size='sm' animation='border' role='status' aria-hidden="true"></Spinner> : null}
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {
                reduxState.toggleSuspendModal ?
                <CommonMethods toggleSuspendModal={reduxState.toggleSuspendModal} {...props}></CommonMethods> : null
            }
            {
                reduxState.toggleRegisterModal ?
                <Register toggleRegisterModal={reduxState.toggleRegisterModal} {...props}></Register> : null
            }
            {
                reduxState.toggleSignInModal?.open ?
                <Signin toggleSignInModal={reduxState.toggleSignInModal} {...props}></Signin> : null
            }
            {
                reduxState.toggleForgotPasswordModal?.open ?
                <ForgotPassword toggleSignInModal={reduxState.toggleSignInModal} {...props}></ForgotPassword> : null
            }
            {
                reduxState.checkExistsModal?.show ?
                <CheckExists checkExistsModal={reduxState.checkExistsModal} {...props}></CheckExists> : null
            }
            {
                reduxState.showErrorModal?.show ?
                    <ErrorModal showErrorModal={reduxState.showErrorModal} {...props}></ErrorModal> : null
            }
            {
                // this will be shown after sigin as a notification alert
                reduxState.toggleNotificationModal?.show ? <NotificationModal {...props}/> : null
            }
            {
                reduxState.membershipModal?.show ? <MembershipModal {...props} /> : null
            }
            <Modal centered show={reduxState?.exploreModal} size="lg" animation={false} backdrop="static" keyboard={false} className={"explore-modal"}>
                <Modal.Header className='d-flex justify-content-between'>
                    <div>

                        <div className="exploreHead">Find your next treasure...</div>
                        <div className="exploresubhead">Select options to browse a selection of items.</div>
                    </div>
                    <div role={"button"} onClick={()=>{
                         store.dispatch({ type: 'EXPLORE_MODAL', payload: false });
                    }}>
                      {crossIcon}
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <ExploreFilterUI 
                    onApply={(filter) => {
                        store.dispatch({ type: 'EXPLORE_MODAL', payload: false });
                        props.history.push(`/explore`, { filter: filter });
                    }}
                        filterData={{}}
                      />
                </Modal.Body>
            </Modal>
        </div>
    )
};
export default connect(state => state)(AppLayoutNew);